module.exports = __webpack_public_path__ + "static/media/active.1513f6ca.svg";